import React, { useState } from "react";
import baseUrl from "../../../api/baseUrl";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import EditIcon from "@mui/icons-material/Edit";
import DeleteDialog from "../../../components/modal/delete/DeleteDialog";
import { toast } from "react-toastify";
import MedicationIcon from "@mui/icons-material/Medication";

function DrugsTr({ data, setData, item, i, editBtn, isMobile }: any) {
  const [deleteOpen, setdeleteOpen] = useState(false);
  const [deleteId, setdeleteId] = useState("");

  const deleteDrugs = (e: any) => {
    setdeleteOpen(true);
    setdeleteId(e);
  };

  const confirmDelete = () => {
    baseUrl
      .delete("/client/prescription/prescription/deletePrescriptionById", {
        headers: { prescriptionid: deleteId },
      })
      .then((response) => {
        setData(data.filter((item: any) => item._id !== deleteId));
        setdeleteId("");
        setdeleteOpen(false);
      })
      .catch((error) => {
        toast.error("Failed to delete. Please try again.");
      });
  };

  // Mobile Card View
  if (isMobile) {
    return (
      <>
        <div className="bg-slate-50 dark:bg-slate-800 rounded-xl p-4 border border-slate-100 dark:border-slate-700">
          <div className="flex items-start justify-between mb-3">
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 bg-gradient-to-br from-emerald-400 to-teal-500 rounded-full flex items-center justify-center text-white">
                <MedicationIcon sx={{ fontSize: 20 }} />
              </div>
              <div>
                <p className="font-semibold text-slate-800 dark:text-slate-200">{item?.drugs}</p>
                <span className="text-xs px-2 py-0.5 bg-indigo-100 dark:bg-indigo-900/40 text-indigo-600 dark:text-indigo-400 rounded-full">
                  {item?.type}
                </span>
              </div>
            </div>
            <span className="text-xs text-slate-400 dark:text-slate-500">#{i + 1}</span>
          </div>

          <div className="mb-3">
            <p className="text-xs text-slate-500 dark:text-slate-400 mb-1">Doses:</p>
            <div className="flex flex-wrap gap-1">
              {item?.dose?.map((d: string, idx: number) => (
                <span
                  key={idx}
                  className="px-2 py-1 bg-white dark:bg-slate-700 border border-slate-200 dark:border-slate-600 rounded-lg text-xs text-slate-600 dark:text-slate-300"
                >
                  {d}
                </span>
              ))}
            </div>
          </div>

          <div className="flex gap-2 pt-3 border-t border-slate-200 dark:border-slate-600">
            <button
              onClick={() => editBtn(item)}
              className="flex-1 flex items-center justify-center gap-1 px-3 py-2 bg-indigo-50 dark:bg-indigo-900/40 text-indigo-600 dark:text-indigo-400 rounded-lg hover:bg-indigo-100 dark:hover:bg-indigo-800/50 transition-colors text-sm font-medium"
            >
              <EditIcon sx={{ fontSize: 18 }} />
              Edit
            </button>
            {!item?.added && (
              <button
                onClick={() => deleteDrugs(item?._id)}
                className="p-2 bg-red-50 dark:bg-red-900/40 text-red-500 dark:text-red-400 rounded-lg hover:bg-red-100 dark:hover:bg-red-800/50 transition-colors"
              >
                <DeleteOutlineIcon sx={{ fontSize: 18 }} />
              </button>
            )}
          </div>
        </div>

        {deleteOpen && (
          <DeleteDialog
            onDelete={() => confirmDelete()}
            onCancel={() => setdeleteOpen(false)}
            title="confirm delete"
            cancel="cancel"
            deletes="delete"
          />
        )}
      </>
    );
  }

  // Desktop Table Row
  return (
    <>
      <tr className="hover:bg-slate-50/50 dark:hover:bg-slate-700/50 transition-colors">
        <td className="px-6 py-3">
          <span className="px-2.5 py-1 text-xs font-semibold rounded-full bg-slate-100 dark:bg-slate-700 text-slate-600 dark:text-slate-400">
            {i + 1}
          </span>
        </td>
        <td className="px-6 py-3">
          <div className="flex items-center gap-3">
            <div className="w-9 h-9 bg-gradient-to-br from-emerald-400 to-teal-500 rounded-full flex items-center justify-center text-white">
              <MedicationIcon sx={{ fontSize: 18 }} />
            </div>
            <span className="font-medium text-slate-800 dark:text-slate-200">{item?.drugs}</span>
          </div>
        </td>
        <td className="px-6 py-3">
          <div className="flex flex-wrap gap-1">
            {item?.dose?.map((d: string, idx: number) => (
              <span
                key={idx}
                className="px-2 py-0.5 bg-indigo-50 dark:bg-indigo-900/40 text-indigo-600 dark:text-indigo-400 rounded-full text-xs font-medium"
              >
                {d}
              </span>
            ))}
          </div>
        </td>
        <td className="px-6 py-3">
          <span className="px-2.5 py-1 bg-emerald-50 dark:bg-emerald-900/40 text-emerald-600 dark:text-emerald-400 rounded-full text-xs font-medium uppercase">
            {item?.type}
          </span>
        </td>
        <td className="px-6 py-3">
          <div className="flex items-center gap-2">
            <button
              onClick={() => editBtn(item)}
              className="p-2 rounded-lg bg-indigo-50 dark:bg-indigo-900/40 text-indigo-600 dark:text-indigo-400 hover:bg-indigo-100 dark:hover:bg-indigo-800/50 transition-colors"
              title="Edit"
            >
              <EditIcon sx={{ fontSize: 18 }} />
            </button>
            {!item?.added && (
              <button
                onClick={() => deleteDrugs(item?._id)}
                className="p-2 rounded-lg bg-red-50 dark:bg-red-900/40 text-red-500 dark:text-red-400 hover:bg-red-100 dark:hover:bg-red-800/50 transition-colors"
                title="Delete"
              >
                <DeleteOutlineIcon sx={{ fontSize: 18 }} />
              </button>
            )}
          </div>
        </td>
      </tr>

      {deleteOpen && (
        <DeleteDialog
          onDelete={() => confirmDelete()}
          onCancel={() => setdeleteOpen(false)}
          title="confirm delete"
          cancel="cancel"
          deletes="delete"
        />
      )}
    </>
  );
}

export default DrugsTr;
